export const SET_CAROUSEL = "settings/SET_CAROUSEL";
export const FETCH_MEDIA = "settings/FETCH_MEDIA";
